import { Document } from "@/models/Document";

export const DocumentRequest = (argDocument) => {
  let document = argDocument.copy();

  if (!document.id) {
    delete document.id;
  }

  delete document.company; // Set by backend
  delete document.creator; // Set by backend

  // Send as formdata because we have a file attached
  var formData = new FormData();
  for (var key in document) {
    formData.append(key, document[key]);
  }

  return formData;
};

export const DocumentResponse = (document) => {
  return new Document(document);
};

export const DocumentsResponse = (documents) => {
  return documents.map((d) => DocumentResponse(d));
};
